import { useCallback, useState } from 'react';
import { SweepNotificationVariant } from '../../../../reducers/notificationsReducer';
import { telemetry } from '../../../../telemetry';
import { useSweepNotifications } from '../../../notifications/useSweepNotifications';

export const useCopyToClipboard = () => {
  const { addNotification } = useSweepNotifications();
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = useCallback(
    async (textToCopy: string) => {
      try {
        await navigator.clipboard.writeText(textToCopy);
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 1000);
      } catch (error) {
        telemetry.captureError(new Error('Failed to copy to clipboard'), error);
        addNotification({
          message: 'Failed to copy to clipboard',
          variant: SweepNotificationVariant.Error,
        });
      }
    },
    [addNotification],
  );

  return {
    handleCopy,
    isCopied,
  };
};
